import axios from 'axios';
import { captureException } from '@sentry/react';

import { setTakeawayOffices } from 'utils/set-takeaway-offices';
import pushEvent, { EVENT_PRODUCT_DETAILS_SEARCH_SHOP_INPUT_RESULT } from 'pushEvent/index';
import { searchTakeAwayOfficesResult } from 'pushEvent/constants';

import {
  SET_DELIVERY_ACTIVE_BUTTON,
  SET_DELIVERY_SORT_DIRECTION,
  SET_DELIVERY_POINTS_TO_SHOW,
  DELIVERY_POINTS_SHOW_COUNT,
  HIDE_DELIVERY_POINTS_TO_SHOW,
  SET_INITIAL_OFFICES,
  SET_TAKEAWAY_FILTERS,
  SET_PRODUCT_DETAILS_OFFICES,
  SET_PRODUCT_DETAILS_OFFICES_RAW,
  SET_BASKET_ID,
  SET_ORDER_INFO,
  SET_POINTS_LOADING,
  GET_DELIVERY_MOVEMENTS,
  GET_DELIVERY_FRANCHIZE,
  GET_DELIVERY_PVZ,
  GET_DELIVERY_POINTS,
  SET_ORDER_LOADING,
} from './constants';
import { getDeliverySortActiveButton, getDeliveryShowPointsCount } from './selectors';
import {
  getDeliveryOfficesListRaw,
  getDeliveryTakeawaySettings,
  getDeliveryOfficesDataUrl,
  getDeliveryOfficesDataFilter,
} from '../selectors';
import { cartApi } from '../../../api';

export const setActiveSortButton = (slug, canBeReversed, reverse) => (dispatch, getState) => {
  const previousSlug = getDeliverySortActiveButton(getState());
  if (slug !== previousSlug) {
    dispatch({
      type: SET_DELIVERY_ACTIVE_BUTTON,
      slug,
    });
    dispatch({
      type: SET_DELIVERY_SORT_DIRECTION,
      reverse: true,
    });
  } else if (slug === previousSlug && canBeReversed) {
    dispatch({
      type: SET_DELIVERY_SORT_DIRECTION,
      reverse,
    });
  }
};

export const setPointsToRenderLength = (pointsCount) => (dispatch, getState) => {
  if (!pointsCount) {
    dispatch({
      type: SET_DELIVERY_POINTS_TO_SHOW,
      pointsCount: DELIVERY_POINTS_SHOW_COUNT,
    });
  } else {
    const previousCount = getDeliveryShowPointsCount(getState());
    dispatch({
      type: SET_DELIVERY_POINTS_TO_SHOW,
      pointsCount: previousCount + pointsCount,
    });
  }
};

export const hidePointsToRender = () => ({
  type: HIDE_DELIVERY_POINTS_TO_SHOW,
  pointsCount: DELIVERY_POINTS_SHOW_COUNT,
});

export const toggleTakeawayFilter = (option) => ({
  type: SET_TAKEAWAY_FILTERS,
  option,
});

export const setAllTakeawayOffices = () => (dispatch, getState) => {
  const state = getState();
  const officesList = getDeliveryOfficesListRaw(state);
  const settings = getDeliveryTakeawaySettings(state);
  const allOffices = setTakeawayOffices(officesList, settings);
  dispatch({
    type: SET_INITIAL_OFFICES,
    allOffices,
  });
};

export const setUnmappedProductDetailsOffices = () => (dispatch, getState) => {
  const state = getState();
  const offices = getDeliveryOfficesListRaw(state);
  dispatch({
    type: SET_PRODUCT_DETAILS_OFFICES,
    offices,
  });
  dispatch(setAllTakeawayOffices());
};

export const setProductDetailsOfficesRaw = () => (dispatch, getState) => {
  const state = getState();
  const url = getDeliveryOfficesDataUrl(state);
  const data = getDeliveryOfficesDataFilter(state);
  axios({
    method: 'post',
    url,
    data,
    responseType: 'json',
  })
    .then((response) => {
      const offices = response.data || null;
      dispatch({
        type: SET_PRODUCT_DETAILS_OFFICES_RAW,
        payload: offices,
      });
      dispatch(setUnmappedProductDetailsOffices());
    })
    .catch(captureException);
};

export const getDeliveryPoints = (payload) => ({
  type: GET_DELIVERY_POINTS,
  payload,
});

export const getDeliveryPointsPVZ = (payload) => ({
  type: GET_DELIVERY_PVZ,
  payload,
});

export const getDeliveryPointsFranchize = (payload) => ({
  type: GET_DELIVERY_FRANCHIZE,
  payload,
});

export const getDeliveryPointsMovements = (payload) => ({
  type: GET_DELIVERY_MOVEMENTS,
  payload,
});

export const setDeliveryPointsLoading = (payload) => ({
  type: SET_POINTS_LOADING,
  payload,
});

export const setBasketId = (payload) => ({
  type: SET_BASKET_ID,
  payload,
});

export const setOrderInfo = (payload) => ({
  type: SET_ORDER_INFO,
  payload,
});

export const setOrderInfoLoading = (payload) => ({
  type: SET_ORDER_LOADING,
  payload,
});

export const createQuickOrder = (item, regionId) => async (dispatch) => {
  const basket = await cartApi.basketCreateBasket(
    cartApi.helpers.createBasketData([item], regionId),
  );
  if (basket) {
    dispatch(setBasketId(basket.id));
  }
};

export const onSearchTakeAwayOfficesResult = (query, pointsLength) => () => {
  if (query) {
    const value =
      !pointsLength ? searchTakeAwayOfficesResult.FAIL : searchTakeAwayOfficesResult.SUCCESS;
    // ym
    pushEvent(EVENT_PRODUCT_DETAILS_SEARCH_SHOP_INPUT_RESULT, { value });
  }
};
